import { render, staticRenderFns } from "./edit-inbox.vue?vue&type=template&id=97d3bc2c&scoped=true&"
import script from "./edit-inbox.vue?vue&type=script&lang=js&"
export * from "./edit-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d3bc2c",
  null
  
)

export default component.exports